/**
 * @typedef {{ valid: true; normalized: string } | { valid: false; error: string }} BillingFieldValidation
 */

const CITY_PATTERN = /^[\p{L}\p{M}][\p{L}\p{M}\s'.-]{0,78}[\p{L}\p{M}]?$/u;

/**
 * @param {string} city
 * @returns {BillingFieldValidation}
 */
export function validateBillingCity(city) {
  const normalized = String(city ?? '').trim();
  if (!normalized) {
    return { valid: false, error: 'La ciudad es obligatoria.' };
  }
  if (normalized.length < 2 || normalized.length > 80) {
    return { valid: false, error: 'La ciudad debe tener entre 2 y 80 caracteres.' };
  }
  if (!CITY_PATTERN.test(normalized)) {
    return { valid: false, error: 'La ciudad contiene caracteres no válidos.' };
  }
  return { valid: true, normalized };
}

/**
 * @param {string} postalCode
 * @param {string} [countryCode]
 * @returns {BillingFieldValidation}
 */
export function validateBillingPostalCode(postalCode, countryCode = 'ES') {
  const normalized = String(postalCode ?? '').trim();
  if (!normalized) {
    return { valid: false, error: 'El código postal es obligatorio.' };
  }

  const country = String(countryCode ?? 'ES').trim().toUpperCase();
  if (country === 'ES') {
    if (!/^\d{5}$/.test(normalized)) {
      return { valid: false, error: 'El código postal debe tener 5 dígitos (España).' };
    }
    return { valid: true, normalized };
  }

  if (normalized.length < 3 || normalized.length > 10) {
    return { valid: false, error: 'El código postal debe tener entre 3 y 10 caracteres.' };
  }
  if (!/^[A-Z0-9][A-Z0-9\s-]{1,8}[A-Z0-9]$/i.test(normalized)) {
    return { valid: false, error: 'El código postal no tiene un formato válido.' };
  }
  return { valid: true, normalized: normalized.toUpperCase() };
}
